import assignToThis from '../../helper/assignToThis';
import { SizingTypeRef, SizingAlgorithmRef } from './SizingReference';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class ScenarioSizing {

    public typeRef: SizingTypeRef | null = SizingTypeRef.pv_and_battery;

    public algorithmRef: SizingAlgorithmRef | null = null;

    public hasBatteryRange: boolean | null = null;

    public pvCapacity: number | null = null; // kept for legacy reason; to be deleted soon!

    public pvMin: number | null = null;

    public pvMax: number | null = null;

    public pvReport: number | null = null;

    public batteryCapacity: number | null = null;

    public batteryMin: number | null = null;

    public batteryMax: number | null = null;

    public batteryReport: number | null = null;

    public uuid: string | null = null;

    public constructor(obj: ObjectOnly = {}) {
      assignToThis(this, obj);

      this.typeRef = this.typeRef ? (SizingTypeRef as any)[this.typeRef] : null;
    }
}
